import { FooterDefault } from 'components/layout';
import { NavBarMobile } from 'components/mobile';
import { SideBarDefault } from 'components/sidebar';
import { motion } from 'framer-motion';
import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useScreenWidth } from 'utils';

export default function LayoutDefault({ children }: { children: ReactNode }) {
  const { isDesktop, isLaptop } = useScreenWidth();
  const location = useLocation();

  const getPathKey = (path: string, level = 2) => {
    // path: "/topics/react/router"
    // level: 1 -> topics
    // level: 2 -> topics/react
    // level: 3 -> topics/react/router
    return path.split('/').splice(1, level).join('/');
  };

  const pageTransitionAnimation = {
    pageAnimate: {
      opacity: 1,
      transition: {
        duration: 0.2,
      },
    },
    pageInitial: {
      opacity: 0,
    },
  };

  return (
    <div className="grid h-screen grid-rows-segments-auto-1fr lg:grid-rows-none lg:grid-cols-segments-auto-1fr bg-segments-lighter-gray">
      {isDesktop || isLaptop ? <SideBarDefault /> : <NavBarMobile />}
      <div
        className="overflow-x-hidden lg:grid lg:grid-rows-segments-1fr-auto"
        id="main-content-layout-parent"
      >
        <motion.div
          key={getPathKey(location.pathname)}
          initial="pageInitial"
          animate="pageAnimate"
          variants={pageTransitionAnimation}
        >
          {children}
        </motion.div>
        <FooterDefault />
      </div>
    </div>
  );
}
